
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.3 27.8l-3 3.7-4.3 1c-.5.1-1 .6-1 1.1l-.6 4.7-5.6 1c-.5.1-.9.5-1 1l-.8 5.4-7.2.8c-.5.1-.8 0-1.1-.4l-1.5-1.9c-.5-.6-.4-1.5.2-2.2l18.7-21c-1.5-4.7-1.7-9.5 2-13.7C28.8 2 36.9 1.7 42.1 6c5.5 4.6 6.6 12.7 1.3 18.5-3.8 4.3-9.5 4.5-14.1 3.3zm5.8-18c-1.1 1.2-1.1 3.1.2 4.3s3.1 1.1 4.3-.1c1.2-1.2 1.1-3.1-.1-4.3-1.3-1.2-3.2-1.2-4.4.1z","fill":"#fff"}})])
          )
        }
      }
    